import { render } from "./ForumView.vue?vue&type=template&id=21b41a6f"
import script from "./ForumView.vue?vue&type=script&lang=js"
export * from "./ForumView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__